import {ThemeProvider as EmotionThemeProvider} from "../../__snowpack__/pkg/@emotion/react.js";
import {ThemeProvider} from "../../__snowpack__/pkg/@mui/material/styles.js";
import React from "react";
import {Provider} from "../../__snowpack__/pkg/react-redux.js";
import {ThemeStyles, uiTheme} from "../common/generic-react.styles.js";
import store from "../redux/store.js";
import {useReduxWhiteLabelTheme} from "../redux/white-label/white-label.hooks.js";
export function withRedux(Component, displayName) {
  const Comp = (props) => /* @__PURE__ */ React.createElement(Provider, {
    store
  }, /* @__PURE__ */ React.createElement(Component, props));
  Comp.displayName = displayName;
  return Comp;
}
export function withStyle(Component, displayName) {
  const Comp = (props) => {
    const [theme] = useReduxWhiteLabelTheme();
    const muiTheme = uiTheme({
      theme
    });
    return /* @__PURE__ */ React.createElement(EmotionThemeProvider, {
      theme: muiTheme
    }, /* @__PURE__ */ React.createElement(ThemeProvider, {
      theme: muiTheme
    }, /* @__PURE__ */ React.createElement(ThemeStyles, null), /* @__PURE__ */ React.createElement(Component, props)));
  };
  Comp.displayName = displayName;
  return Comp;
}
export function withReduxAndStyle(Component, displayName) {
  return withRedux(withStyle(Component, displayName), displayName);
}
